import JSBI from 'jsbi'
import { Interface } from '@ethersproject/abi'
// import IPeripheryPaymentsWithFee from '@uniswap/v3-periphery/artifacts/contracts/interfaces/IPeripheryPaymentsWithFee.sol/IPeripheryPaymentsWithFee.json'
import EscrowManger from '@netixsol01/escrowmanagerv2/artifacts/contracts/EscrowManagerV2.sol/EscrowManagerV2.json'
import { Percent, Token, validateAndParseAddress } from '@uniswap/sdk-core'
import { toHex } from './utils/calldata'

export interface FeeOptions {
  /**
   * The percent of the output that will be taken as a fee.
   */
  fee: Percent

  /**
   * The recipient of the fee.
   */
  recipient: string
}

export abstract class Payments {
  public static INTERFACE: Interface = new Interface(EscrowManger.abi)

  /**
   * Cannot be constructed.
   */
  private constructor() {}

  private static encodeFeeBips(fee: Percent): string {
    return toHex(fee.multiply(10_000).quotient)
  }

  public static encodeUnwrapWETH9(
    source: string,
    amountMinimum: JSBI,
    recipient: string,
    feeOptions?: FeeOptions
  ): string {
    source = validateAndParseAddress(source)
    recipient = validateAndParseAddress(recipient)

    if (!!feeOptions) {
      const feeBips = this.encodeFeeBips(feeOptions.fee)
      const feeRecipient: string = validateAndParseAddress(feeOptions.recipient)

      return Payments.INTERFACE.encodeFunctionData('unwrapWETH9WithFee', [
        source,
        toHex(amountMinimum),
        // recipient,
        feeBips,
        feeRecipient
      ])
    } else {
      return Payments.INTERFACE.encodeFunctionData('unwrapWETH9', [
        source,
        toHex(amountMinimum)
        // , recipient
      ])
    }
  }

  public static encodeSweepToken(
    source: string,
    token: Token,
    amountMinimum: JSBI,
    recipient: string,
    feeOptions?: FeeOptions
  ): string {
    source = validateAndParseAddress(source)
    recipient = validateAndParseAddress(recipient)

    if (!!feeOptions) {
      const feeBips = this.encodeFeeBips(feeOptions.fee)
      const feeRecipient: string = validateAndParseAddress(feeOptions.recipient)

      return Payments.INTERFACE.encodeFunctionData('sweepTokenWithFee', [
        source,
        token.address,
        toHex(amountMinimum),
        // recipient,
        feeBips,
        feeRecipient
      ])
    } else {
      return Payments.INTERFACE.encodeFunctionData('sweepToken', [
        source,
        token.address,
        toHex(amountMinimum)
        // recipient
      ])
    }
  }

  public static encodeRefundETH(source: string): string {
    source = validateAndParseAddress(source)
    return Payments.INTERFACE.encodeFunctionData('refundETH', [source])
  }
}
